export const PERIOD_SEARCH_PARAMS = {
  assignmentDetails: 'assignment_details',
  closeAssignment: 'close',
  confirmAssignment: 'confirm',
  confirmCancel: 'cancel',
  hide_assignment: 'hide',
  jobId: 'job_id',
};

export const CREATE_JOB_URL = '/organisation/period_jobs/create/';
